// Filter search: specific by clicked node type
$('.js-node-type-filter').on('click', function () {
    $('.js-node-type-filter').removeClass(['active', 'border-primary', 'fw-bold']).addClass(['bg-transparent', 'text-gray-verydark', 'border-dark']);
    $(this).addClass(['active', 'border-primary', 'fw-bold']).removeClass(['bg-transparent', 'text-gray-verydark', 'border-dark']);

    filterSearchResultsByActiveFilter(this);
});

function filterSearchResultsByActiveFilter(currentFilter) {
    const nodeType = $(currentFilter).data('node-type');
    const isAllSelected = nodeType == 'all';

    if (isAllSelected) {
        // Show all
        $('.search').find('.results-result').removeClass('d-none').addClass('d-block');
    } else {
        // Reset Filter
        $('.search').find('.results-result').removeClass('d-block').addClass('d-none');

        // Filter list on nodeType
        $('.search').find('.results-result[data-node-type*=' + nodeType + ']').removeClass('d-none').addClass('d-block');
    }
}
